// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"f218e010","264":"c0805b61","461":"c863597d","636":"22b4bc59","995":"5f136344"}[chunkId] + ".chunk.js";
};